<template>
  <RevCard
    class="relative h-full border-transparent p-16"
    data-qa="productCard"
    :hoverable="true"
  >
    <div class="text-static-danger-hi caption-bold">
      {{ i18n(translations.cardLabel) }}
    </div>
    <div class="flex pt-8 md:flex-col">
      <div class="flex justify-center">
        <RevIllustration
          alt=""
          data-test="product-card-image"
          :height="128"
          sizes="128px"
          :src="imageSrc"
          :width="128"
        />
      </div>
      <div class="pl-8 md:pl-0 md:pt-24">
        <h2 class="body-1-bold">
          <RevButtonBase
            class="after:focus-visible-outline-default-hi after:rounded-lg after:absolute after:inset-0 after:bg-transparent focus-visible:outline-none"
            :to="`/${currentLocale}/p/iphone-18-pro`"
          >
            {{ i18n(translations.title) }}
          </RevButtonBase>
        </h2>
        <RevRating
          class="pt-6"
          :score="0"
          :show-score-label="false"
          size="extra-small"
        />
        <div class="pt-6">
          <div class="caption-bold">
            {{ i18n(translations.priceStartAt) }}
          </div>
          <div class="heading-2">
            {{ i18n(translations.price) }}
          </div>
          <div class="text-static-default-low body-2 line-through">
            {{ i18n(translations.strikedPrice) }}
          </div>
        </div>
      </div>
    </div>
  </RevCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevButtonBase } from '@ds/components/ButtonBase'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevRating } from '@ds/components/Rating'

import translations from './Iphone17ProductCard.translations'

const props = defineProps<{
  product: { id: string; position?: number }
}>()

const i18n = useI18n()
const currentLocale = useI18nLocale()

const imageSrc = computed(() => {
  return props.product.position === 2
    ? '/img/product-card/Iphone17-Yellow.png'
    : '/img/product-card/Iphone17-Black.png'
})
</script>
